/**
 * @description 문자열이 숫자와 하이픈(-) 이루어져있는지 체크하는 함수
 * @returns boolean, (true: 허용하는 문자로만 이루어짐, false: 허용하지 않는 문자열 포함)
 */

const validateNumberAndHyphenOnly = (value: string): boolean => {
  const regex = /^[0-9-]*$/;

  return regex.test(value);
};

export default validateNumberAndHyphenOnly;
